@if (showBanner) {
  <app-standard-page class="banner">
    <div class="card vertical ms-0 container p-0">
      <div class="p-3">
        <h3>Welcome to FinQuery Fixed Assets</h3>

        <div class="row">
          <div class="col-12">
            <p>
              This is your new asset register and it's connected to
              {{ integrationName }}.
            </p>
            <p class="mb-0"></p>
          </div>

          @if (demoRegister) {
            <div class="col-4">
              <p class="mb-1">
                We've made a demo register so you can test FinQuery Fixed
                Assets' full functionality.
              </p>
              <a
                data-dd-action-name="settings-banner.demo-register-link"
                [routerLink]="demoLink"
                class="btn btn-outline w-100"
              >
                <i-lucide name="play"></i-lucide>
                Go To Demo Register
              </a>
            </div>
          }

          <div class="col-4">
            <p class="mb-1">
              Or you can start setting this register up by adding asset groups
              and assets.
            </p>
            <a
              data-dd-action-name="settings-banner.get-started-link"
              [routerLink]="assetsLink"
              class="btn btn-outline w-100"
            >
              <i-lucide name="box"></i-lucide>
              Get Started
            </a>
          </div>

          <div class="col-4">
            <p class="mb-1">
              If you want it done for you, we can arrange setup and data
              conversion.
            </p>
            <a
              data-dd-action-name="settings-banner.done-for-you-link"
              href="https://www.finquery.com"
              target="_blank"
              class="btn btn-outline w-100"
            >
              <i-lucide name="upload-cloud"></i-lucide>
              See Done For You Options
            </a>
          </div>
        </div>
      </div>
    </div>
  </app-standard-page>
}
